export default {
    updatePreviewData(state, payload) {
        Object.assign(state.formData, payload);
    },

    clearPreview() {
        this.preview = "";
    },

    updatePreview(state, payload) {
        state.preview = payload;
    },

    updateIsLoading(state, payload) {
        state.isLoading = payload;
    },

    updateIsGenerating(state, payload) {
        state.isGeneratingAssets = payload;
    },

    updateTestFormDialogOpen(state, payload) {
        state.testFormDialogOpen = payload;
    },

    updatePdfDialogOpen(state, payload) {
        state.pdfDialogOpen = payload;
    },

    updatePdfPreview(state, payload) {
        state.pdfPreview = payload;
    },

    updatePublishAssetsDialogOpen(state, payload) {
        state.publishAssetsDialogOpen = payload;
    },

    updatePreviewImage(state, payload) {
        state.preview_image = payload;
    },

    triggerError(state, payload) {}
}